import { render, staticRenderFns } from "./StudentChanger.vue?vue&type=template&id=2ce65e9d"
import script from "./StudentChanger.vue?vue&type=script&lang=js"
export * from "./StudentChanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports